<template>
  <div>
    <!-- サイドメニュー -->
    <v-navigation-drawer disable-route-watcher app v-model="drawer" clipped>
      <!-- メニュー -->
      <v-list dense nav flat class="pa-0 pt-2">
        <template>
          <v-list-group
            no-action
            :prepend-icon="links[0].icon"
            :key="links[0].name"
            v-model="links[0].active"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ links[0].name }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <!-- ダッシュボード -->
            <template v-for="list in sideMenuItemsAll">
            <v-list-group
              no-action
              sub-group
              :key="list[0].kki_nm"
              v-model="list.active"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ list[0].kki_nm }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            <v-list-item
              color="indigo"
              v-for="list_child in list"
              :key="list_child"
              @click="loadUrl(list_child.id, list_child.kki_cd, list_child.link)"
            >
              <v-list-item-title>
                {{ list_child.name }}
              </v-list-item-title>
            </v-list-item>
            </v-list-group>
            </template>
          </v-list-group>
          <!-- マスタ管理 -->
          <v-list-group
            no-action
            v-if="masterKanriFlg"
            :prepend-icon="links[1].icon"
            :key="links[1].name"
            v-model="links[1].active"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ links[1].name }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="list in links[1].children"
              :key="list.name"
              :to="list.link"
            >
              <v-list-item-title>
                <v-icon class="mr-1">label</v-icon>
                {{ list.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    <!-- end サイドメニュー -->
    </v-navigation-drawer>
    <!-- ヘッダー -->
    <v-app-bar color="indigo" dark app clipped-left dense>
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-img :src="logoimgPath" max-width="145" :aspect-ratio="6/1"></v-img>
      <v-toolbar-title class="px-2" v-if="!breakpoint">
        {{user.kiyk_nm}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <template v-if="mainMenuFlg">
          <v-btn v-if="breakpoint" text to='/KiykskSntk'>
            <v-icon>apartment</v-icon>
          </v-btn>
          <v-btn v-else width="150" text to='/KiykskSntk'>
            <v-icon class="mr-1">apartment</v-icon>契約先選択
          </v-btn>
        </template>
        <!-- ユーザinfo-->
        <v-menu
          v-model="dialog"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
          v-bind="attrs"
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- スマホサイズの場合は文字を表示しない -->
            <v-btn
              v-if="breakpoint"
              text
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>person</v-icon>
            </v-btn>
            <!-- PCサイズの場合は文字を表示する -->
            <v-btn
              v-else
              text width="150"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="mr-1">person</v-icon>ユーザー情報
            </v-btn>
          </template>
          <v-card class="pa-2">
            <v-container>
              <v-row justify="center" align-content="center">
                <v-card-text class="pa-1 text-center">{{userName}}</v-card-text>
              </v-row>
            <v-divider></v-divider>
            <v-row justify="center" align-content="center">
              <v-card-actions>
                <v-btn
                    @click="showDetail"
                    class="text-capitalize" outlined
                  >アカウント情報変更</v-btn>
                <v-btn
                  @click="logout"
                  class="text-capitalize" outlined
                >Logout</v-btn>
              </v-card-actions>
            </v-row>
          </v-container>
        </v-card>
      </v-menu>
      <!-- userInfo end -->
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import myAxios from '../../axios/myAxios.js'
import MsgList from './MsgList'

export default {
  name: 'MstrHedr',
  props: {
  },
  data () {
    return {
      logoimgPath: require('@/assets/img/MIoTASUsimple_wR.png'),
      drawer: null,
      userInfo: false,
      mainMenuFlg: false,
      dialog: false,
      masterKanriFlg: false,
      sideMenuItems: [],
      sideMenuMasterItems: [],
      sideMenuItemsAll: [],
      user: {
        user_cd: '',
        name: '',
        email_addr: '',
        kngn_typ: '',
        kiyk_cd: '',
        kiyk_nm: ''
      },
      connectionErrMsg: MsgList.MSG_CONNETION_ERROR,
      dashboardUrl: 'about:blank',
      links: [
        {
          name: 'ダッシュボード',
          icon: 'equalizer',
          model: false,
          link: '',
          children: []
        },
        {
          name: 'マスタ管理',
          icon: 'folder_shared',
          model: false,
          link: '',
          children: []
        }
      ]
    }
  },
  created () {
    // ログインセッションの確認
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result

      // ログインセッションを確認できなければログイン画面に遷移する
      if (!(status && result)) {
        alert(MsgList.MSG_SES_CANNOT_CONFIRM)
        this.$router.push('/')
        this.$store.dispatch('appSetting/fLogin')
      }
      // ユーザinfoポップアップ用の情報を取得
      myAxios.get('/api/common/session_manager', {type: 'userinfo_popup'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status && result) {
          this.$store.dispatch('appSetting/resaveUserName', res.data.name)
          this.user.email_addr = res.data.email_addr
          this.user.user_cd = res.data.user_cd
          // storeからユーザ名を取得する
          this.user.name = this.$store.getters['appSetting/userName']
        }
      })
      // フットパスの設定
      myAxios.get('/api/common/session_manager', {type: 'kiyk_single_flg'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status) {
          this.mainMenuFlg = !result
        }
      })
      // 権限区分と契約コードの取得
      myAxios.get('/api/common/session_manager', {type: 'userinfo_kngn_kiyk'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status && result) {
          this.user.kngn_typ = res.data.kngn_typ
          this.user.kiyk_cd = res.data.kiyk_cd
          // dashboard,masterサイドメニュー一覧を取得する
          myAxios.get('/api/dshbord/dashboard_menu').then(res => {
            this.sideMenuMasterItems = res.data.master_list
            this.links[1].children = this.sideMenuMasterItems
            // 2つのKKI_CDがある場合
            this.sideMenuItemsAll = res.data.dash_list_all
            // eslint-disable-next-line handle-callback-err
            if (this.sideMenuMasterItems.length === 0) {
              this.links[1].children = [{name: '権限がありません'}]
            }
            if (this.sideMenuItemsAll.length === 0) {
              this.sideMenuItemsAll = [{kki_nm: '権限がありません'}]
            }
          }).catch(err => {
            console.log(err)
            this.sideMenuItems = []
            this.sideMenuMasterItems = []
            this.links[0].children = [{name: '権限がありません'}]
            this.links[1].children = [{name: '権限がありません'}]
          })
          // 契約名を取得する
          myAxios.get('/api/kiyksk_mstr/keiyakusaki_master_session_getter').then(res => {
            this.user.kiyk_nm = ' ' + res.data.kiyk_nm.trim()
            // eslint-disable-next-line handle-callback-err
          })
        }
      })
    })
    // マスタ管理ボタン表示可否の取得
    myAxios.get('/api/login/kiyksk_sntk_master_kanri').then(res => {
      const status = res.data.status
      const result = res.data.result

      // 取得したマスタ管理フラグを設定する
      if (status) {
        this.masterKanriFlg = result
      }
    // eslint-disable-next-line handle-callback-err
    }).catch(err => {
      alert(this.connectionErrMsg)
      this.masterKanriFlg = false
    })
  },
  methods: {
    logout: function () {
      // ポップアップ消す
      this.dialog = false
      // ログアウト処理
      // storeの情報を初期化
      this.$store.dispatch('appSetting/resetId')
      this.$store.dispatch('appSetting/resetKki')
      myAxios.get('/api/common/session_manager', {type: 'logout'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        // logoutできたら
        if (!(status && result)) {
        }
        this.$router.push('/')
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        alert(this.connectionErrMsg)
        this.$router.push('/')
      })
    },
    /**
     * メニューIDをサーバーに送信してQuickSightのダッシュボードURLを取得する
     */
    loadUrl (id, kki, url) {
      this.$store.dispatch('appSetting/selectKki', kki)
      this.$store.dispatch('appSetting/selectItem', id)
      myAxios.get('api/dshbord/dashboard_url', { mn_cd: id, kki_cd: kki }).then(res => {
        if (res.data.Status !== 200) {
          alert('画像読み込みに失敗しました。管理者にお問い合わせください。')
        } else {
          this.dashboardUrl = res.data.EmbedUrl
          this.$router.push(url)
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        console.log('header error')
        alert(MsgList.MSG_SES_CANNOT_CONFIRM)
        this.$router.push('/')
      })
    },
    getUserName () {
      this.user.name = this.$store.getters['appSetting/userName']
    },
    showDetail () {
      this.dialog = false
      this.$router.push({path: '/UsrPassChange'})
    }
  },
  computed: {
    headerLink: function () {
      if (this.mainMenuFlg) {
        return '/KiykskSntk'
      } else {
        return '/initial'
      }
    },
    // ヘッダーに表示するユーザ名を調べる
    userName () {
      const userNm = this.$store.getters['appSetting/userName']
      return userNm
    },
    // スマホサイズかどうか調べる
    breakpoint () {
      var phoneFlg = false
      const breakpoint = this.$vuetify.breakpoint.name
      switch (breakpoint) {
        case 'xs':
          phoneFlg = true
          break
        case 'sm':
          phoneFlg = true
          break
        case 'md':
          phoneFlg = false
          break
        case 'lg':
          phoneFlg = false
          break
        case 'xl':
          phoneFlg = false
          break
        default:
          phoneFlg = false
      }
      return phoneFlg
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/MstrHedr.vue